import React from 'react';
import { View, KeyboardAvoidingView, Platform, ScrollView, StyleSheet } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { useTranslation } from 'react-i18next';
import { RootStackParamList } from '../types';
import { AppHeader, ChangePasswordForm } from '../components';
import { Colors, Spacing } from '../constants';
import { useResponsive } from '../utils/responsive';

type Props = NativeStackScreenProps<RootStackParamList, 'ChangePassword'>;

export const ChangePasswordScreen: React.FC<Props> = ({ navigation }) => {
  const { t } = useTranslation();
  const { isDesktop } = useResponsive();

  const handleDone = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('Profile');
    }
  };

  return (
    <View style={[styles.container, !isDesktop && styles.containerMobile]}>
      {!isDesktop && (
        <AppHeader
          navigation={{ ...navigation, goBack: handleDone }}
          currentScreen="Profile"
          title={t('screens.changePassword.title')}
          showBackButton
        />
      )}
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={styles.flex}
      >
        <ScrollView
          contentContainerStyle={isDesktop ? styles.scrollContentDesktop : styles.scrollContentMobile}
          keyboardShouldPersistTaps="handled"
        >
          <ChangePasswordForm onDone={handleDone} onCancel={handleDone} showTitle={isDesktop} />
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.background,
  },
  containerMobile: {
    backgroundColor: Colors.white,
  },
  flex: {
    flex: 1,
  },
  scrollContentDesktop: {
    flexGrow: 1,
    justifyContent: 'center',
    padding: Spacing.xl,
    alignItems: 'center',
  },
  scrollContentMobile: {
    padding: Spacing.base,
    paddingBottom: Spacing['3xl'],
  },
});
